import request from '@/utils/request'

// 登录方法
export function login(username, password, phone) {
  const data = {
    username,
    password,
    phone
  }
  return request({
    url: '/login/login',
    method: 'post',
    data: data,
    headers: {
      isToken: false
    }

  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/login/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}







// WEBPACK FOOTER //
// ./src/api/login/index.js